import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import * as Actions from 'app/store/actions';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'app/modules/react-redux';
import { withRouter } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import ListItemButton from '@mui/material/ListItemButton';
import FuseNavBadge from '../FuseNavBadge';

const useStyles = makeStyles((theme) => ({
	item: (props) => ({
		height: 40,
		width: 'calc(100% - 16px)',
		borderRadius: '0 20px 20px 0',
		paddingRight: 12,
		paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
		'&.active': {
			backgroundColor: `${theme.palette.secondary.main} !important`,
			color: `${theme.palette.secondary.contrastText} !important`,
			pointerEvents: 'none',
			transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
			'& .nav-list-item-text-primary': {
				color: 'inherit',
			},
			'& .nav-list-item-icon': {
				color: 'inherit',
			},
		},
		'& .nav-list-item-icon': {
			marginRight: 16,
		},
		'& .nav-list-item-text': {},
		color: theme.palette.text.primary,
		textDecoration: 'none!important',
	}),
}));

const FuseNavVerticalLink = (props) => {
	const dispatch = useDispatch();
	// const userRole = useSelector(({ auth }) => auth.user.role);

	const theme = useTheme();
	const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
	const { item, nestedLevel } = props;
	const classes = useStyles({
		itemPadding: nestedLevel > 0 ? 40 + nestedLevel * 16 : 24,
	});
	const { t } = useTranslation();

	// const hasPermission = useMemo(() => FuseUtils.hasPermission(item.auth, userRole), [item.auth, userRole]);

	// if (!hasPermission) {
	// 	return null;
	// }

	const IconComponent = item.Icon;

	return (
		<ListItemButton
			component="a"
			href={item.url}
			target={item.target ? item.target : '_blank'}
			className={clsx(classes.item, 'nav-list-item mt-12 starter:text-white')}
			onClick={(_ev) => mdDown && dispatch(Actions.navbarCloseMobile())}
			role="button"
		>
			<IconComponent className="nav-list-item-icon text-16 flex-shrink-0 scale-150" color="action" />
			<ListItemText
				className="nav-list-item-text"
				primary={item.translate ? t(item.translate) : item.title}
				classes={{ primary: 'text-14 nav-list-item-text-primary' }}
			/>
			{item.badge && <FuseNavBadge badge={item.badge} />}
		</ListItemButton>
	);
};

FuseNavVerticalLink.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		icon: PropTypes.string,
		url: PropTypes.string,
		target: PropTypes.string,
	}),
};
const NavVerticalLink = withRouter(React.memo(FuseNavVerticalLink));

export default NavVerticalLink;
